import { IApplicationState } from '../../../types/redux';

export const getCurrentPage = (state: IApplicationState): number => {
  return state.location.page;
};
